var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSessions = function SvgSessions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "none",
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4.38 3.4v0A2.38 2.38 0 0 0 2 5.78V14a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V5.78a2.38 2.38 0 0 0-2.38-2.38v0",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.4 2.2v1a1 1 0 0 0 1-1h-1Zm-.6 0v1-1Zm4.4 0v1-1Zm-.6 0h-1a1 1 0 0 0 1 1v-1Zm-2.2 0c0-.11.09-.2.2-.2V0a2.2 2.2 0 0 0-2.2 2.2h2Zm-1.6 1h.6v-2h-.6v2Zm-.4.4c0-.22.18-.4.4-.4v-2a2.4 2.4 0 0 0-2.4 2.4h2Zm.4.4a.4.4 0 0 1-.4-.4h-2A2.4 2.4 0 0 0 5.8 6V4Zm4.4 0H5.8v2h4.4V4Zm.4-.4a.4.4 0 0 1-.4.4v2a2.4 2.4 0 0 0 2.4-2.4h-2Zm-.4-.4c.22 0 .4.18.4.4h2a2.4 2.4 0 0 0-2.4-2.4v2Zm-.6 0h.6v-2h-.6v2ZM8.4 2c.11 0 .2.09.2.2h2A2.2 2.2 0 0 0 8.4 0v2Zm-.8 0h.8V0h-.8v2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5.31 7.46h5.38M5.31 10.54h5.38M5.31 13.6h5.38",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgSessions;